/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import plcLogo from '@/assets/sap/SAP-Logo.svg'

const handleStyleLeft = { left: -2, top: 44 }

function ErpNode({ data, isConnectable }) {
  return (
    <div className="custom-node-plc plc-limits">
      <Handle type="target" position={Position.Left} style={handleStyleLeft} />
      <Handle type="source" position={Position.Left} style={handleStyleLeft} />

      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={plcLogo} alt="PLC Logo" className="custom-node-plc-logo" />
          </div>
          <div className="text-center">
            <b>ERP</b>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ErpNode
